import * as React from "react";
import { Segment, Header, Grid, Divider, Icon } from "semantic-ui-react";
import ClickToCopy from "../components/ClickToCopy";

export default function QuickStartSection() {
  return (
    <>
      <Header as="h1">Quick Start</Header>
      <Segment secondary>
        <Grid columns="2" stackable textAlign="center">
          <Divider vertical>Or</Divider>
          <Grid.Row>
            <Grid.Column width="8">
              <code>
                <Icon name="terminal" /> yarn add object-accumulator {"  "}
                <ClickToCopy text="yarn add object-accumulator" />
              </code>
            </Grid.Column>
            <Grid.Column width="8">
              <code>
                <Icon name="terminal" /> npm install --save object-accumulator{" "}
                {"  "}
                <ClickToCopy text="npm install --save object-accumulator" />
              </code>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </>
  );
}
